import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";

import { config } from "config/config";
import { parseQueryParams } from "helpers/url";

import { UnsubscribeCard } from "./UnsubscribeCard";

type NotificationType = "agentNotifications" | "weeklyReports";

const notificationLabels: Record<NotificationType, string> = {
  agentNotifications: "agent notifications",
  weeklyReports: "weekly reports",
};

export const EmailUnsubscribe: FC = () => {
  const { agentID } = useParams<{ agentID: string }>();
  const queryParams = parseQueryParams(window.location.search);
  const notificationType = queryParams.type as NotificationType | undefined;
  const notificationName = notificationType ? notificationLabels[notificationType] : "notifications";

  useEffect(() => {
    fetch(`${config.api}/v1/agents/${agentID}/unsubscribeEmail${window.location.search}`, {
      method: "POST",
      body: JSON.stringify({ "List-Unsubscribe": "One-Click" }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }, []);

  return (
    <UnsubscribeCard
      title="You've been unsubscribed"
      description={`You are now unsubscribed from ${notificationName}. Visit settings to check other notifications you may be receiving.`}
      withActions
    />
  );
};
